// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Calendar: React.FC<{ width?: number; height?: number }> = ({ width = 14, height = 15 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 14 15">
            <path
                fill="currentColor"
                d="M4 0c-.563 0-1 .438-1 1v1H2C.906 2 0 2.906 0 4v1.5h14V4c0-1.094-.906-2-2-2h-1V1c0-.563-.438-1-1-1-.563 0-1 .438-1 1v1H5V1c0-.563-.438-1-1-1ZM0 7v6c0 1.094.906 2 2 2h10c1.094 0 2-.906 2-2V7H0Z"
            />
        </svg>
    );
};

export default React.memo(Calendar);
